import React, { useEffect, useState } from 'react';
import Article from '../components/Article.js';
import Loader from '../components/Loader.js';
import '../styles/Articles.css';
import { getArticlesAPI } from '../apis/apiBaltee.js';

const Articles = () => {
  const [articlesData, setArticlesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const articles = await getArticlesAPI();
        setArticlesData(articles);
      } catch (error) {
        console.error('Erreur lors du chargement des articles :', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div className="articles-container">
      <h1 className="articles-title">Nos Articles</h1>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="articles-grid">
          {articlesData.map((articleObj, index) => (
            <Article
              key={index}
              title={articleObj.title}
              path={`/articles/${articleObj.id}`}
              htmlTitle={articleObj.htmlTitle}
              content={articleObj.content}
              media={articleObj.media}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Articles;
